export default class BootstrapFixes {

  static init() {

    this.fix_collapse_a11y();
    this.fix_sub_dropdowns();

  }

  /**
   *
   */
  static fix_collapse_a11y() {

    jQuery('[data-bs-toggle="collapse"]').on('click', function() {

      let $target = jQuery(jQuery(this).attr('data-bs-target'));
      $target.attr('aria-hidden', $target.attr('aria-hidden') === 'false' ? 'true' : 'false');

    });

  }


  static fix_sub_dropdowns() {
    const dropdowns = document.querySelectorAll('.dropdown-sub-items-toggle');

    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('click', function (e) {
        e.stopPropagation();
        const submenu = e.target.closest('li').querySelector('.dropdown-sub-items');
        let $target = jQuery(e.target).closest('.dropdown-sub-items-toggle');
        $target.attr('aria-expanded', $target.attr('aria-expanded') === 'false' ? 'true' : 'false');
        submenu.classList.toggle('show');
      });
    });
  }


}
